const createPulseAnimation = (center) => {
  return center.x && center.y
    ? `<g xmlns="http://www.w3.org/2000/svg"
    data-js="pulse-animation"
    class="hide u-disable-cursor"
    transform="translate(${center.x}, ${center.y})">
    <circle class="pulse-animation pulse-animation__first-circle" r="7"></circle>
    <circle class="pulse-animation pulse-animation__second-circle" r="7"></circle>
    <circle class="pulse-animation pulse-animation__third-circle" r="7"></circle>
  </g>`
    : '';
};

export default createPulseAnimation;
